import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from '@/stores/hooks';
import { selectCodeBrand } from '@/stores/selectors';

/** Screens before OTP verify always keep Dice_bg (brand BG starts on first questionnaire). */
const PRE_OTP_PATHS = new Set(['/', '/age_smoker', '/pdpa', '/uniquecode', '/otp']);

/**
 * Shared full-bleed background for Home and survey flow pages.
 * Pre-OTP screens always use Dice_bg. After OTP (`/smokerprofile` → `/tng`),
 * background follows `UniqueCode.codeBrand`: LBS → LBS_bg, Dice → Dice_bg.
 * Keep background utility classes as full literals so Tailwind JIT picks them up.
 */
export default function SurveyBackgroundLayout({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  const codeBrand = useAppSelector(selectCodeBrand);
  const useLbsBg = codeBrand === 'LBS' && !PRE_OTP_PATHS.has(pathname);

  return (
    <div
      className={
        useLbsBg
          ? "relative flex h-full min-h-0 flex-1 flex-col px-6 pb-12 bg-top bg-no-repeat bg-[length:100%_auto] bg-[url('/images/LBS_bg.jpg')]"
          : "relative flex h-full min-h-0 flex-1 flex-col px-6 pb-12 bg-top bg-no-repeat bg-[length:100%_auto] bg-[url('/images/Dice_bg.jpg')]"
      }
    >
      <div
        className="pointer-events-none absolute inset-0 bg-gradient-to-b from-black/25 via-transparent to-black/45"
        aria-hidden
      />
      {children}
    </div>
  );
}
